import { PreviousAddressFormNew_MX } from './mixed';

export const PreviousAddressFormNew = {
  /**
   * PrivateLease
   */
  PL: PreviousAddressFormNew_MX,
};
